import React, { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../services/apiConfig";
const Wait: React.FC = () => {
  const { id } = useParams();
  const [waitingCount, setwaitingCount] = useState<number>(0);
  const [waitingNumber, setwaitingNumber] = useState<number>(0);
  const [clubname, setclubname] = useState<String>("");
  const [mobileNumber, setmobileNumber] = useState<number>(0);
  
  
  useEffect(() => {
    // console.log("(Wait) DNet 토큰 파라미터  >>>> id ", id);
  }, []);

  useEffect(() => {
    getnumber();
  }, []);
  const Refreshclick = async () => {
    console.log("새로고침");
    window.location.reload();
  }
  const installclick = async () => {
    const url = 'https://zrr.kr/ErbN';
    window.open(url, '_blank');
  }
  const getnumber = async () => {
    try {
      const response = await axios.get(
         `${API_BASE_URL}/club/guest/waiting/${id}`,
        {
          headers: {

          },
        }
      );
      console.log(response);
      console.log("(Wait) API Response:", response.data.data.clubName);
      console.log("(Wait) API Response:", response.data.data.mobileNumber);
      console.log("(Wait) API Response:", response.data.data.waitingCount);
      console.log("(Wait) API Response:", response.data.data.waitingNumber);
      setclubname(response.data.data.clubName)
      setmobileNumber(response.data.data.mobileNumber.slice(-4))
      setwaitingCount(response.data.data.waitingCount)
      setwaitingNumber(response.data.data.waitingNumber)
    } catch (error) {}
  };
  
  return (
    <div style={{ width: "300px", height: "100%", marginLeft:"50px"}}>
      <div
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          width: "100%",
          textAlign: "left",
          margin: "30px",
        }}
      >
        대기
      </div>
      <div
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          width: "100%",
          textAlign: "left",
          marginLeft: "30px",
        }}
      >
        {mobileNumber}님, {clubname}
      </div>
      <div
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          width: "100%",
          textAlign: "left",
          marginLeft: "30px",
        }}
      >
        대기 번호는 {waitingNumber}입니다
      </div>
      <div style={{ width: "100%", textAlign: "left", margin: "30px" }}>
        나의 대기 순번은 {waitingCount}번째입니다.
      </div>
      <img
        src="../asset/img/Clock.png" //공지저장버튼
        alt="clock"
        style={{
          width: "50%",
          height: "50%",
          cursor: "pointer",
        }}
        // onClick={clocksaveClick}
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          marginTop: "30px",
        }}
      >
        <img
          src="../asset/img/installButton.png"
          alt="install button"
          style={{
            width: "80%",
            height: "50%",
            cursor: "pointer",
          }}
          onClick={installclick}
        />
        <img
          src="../asset/img/RefreshButton.png"
          alt="refresh button"
          style={{
            width: "80%",
            height: "50%",
            cursor: "pointer",
            marginTop: "10px",
          }}
          onClick={Refreshclick}
        />
      </div>
      <div style={{ marginTop: "-70%",marginLeft:"2%",fontSize: "24px",fontWeight: "bold",}}>{waitingCount}</div>
    </div>
  );
};

export default Wait;

